import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Card, Tooltip, Button, Input, Table } from 'antd'

import { req_page_ams_alumni, req_downloadfile_ams_employer } from '../../api'

import { API_BASE, PAGE_SIZE, SORT_FIELD_NAME, SORT_UP_DOWN } from '../../utils/contrains'
import { usrRole, getSchoolAcademicYear  } from '../../utils/dataUtil'

class EmployerManage extends Component {

    state = {
        loading: false,
        deviceWidth: 0,
        userLevel: 'NORMAL',
        item: {},
        // 分頁參數
        items: [],
        pagination: {
            current: 1,
            pageSize: PAGE_SIZE,
            total: 0
        },
        columnSort: SORT_FIELD_NAME,
        orderBy: SORT_UP_DOWN,
        searchField: 'YearGrade',
        searchValue: getSchoolAcademicYear() - 2,
        filterStatus: '就業',

        domnloadFile: '',
        isShowModal: false
    }

    UNSAFE_componentWillMount() {
        window.removeEventListener("resize", this.resize.bind(this));
        this.resize()
        this.init_columns()
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.api_page_items(1)
    }

    resize() {
        this.setState({ deviceWidth: window.innerWidth });
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_page_items = async (current) => {
        this.current = current // 保存當前頁，給其他方法可看到
        const { pageSize } = this.state.pagination
        const { searchField, searchValue, columnSort, orderBy, filterStatus } = this.state
        const { token, userCode, role } = this.props.user
        //console.log(searchValue)
        var userLevel = usrRole(role)
        this.setState({ userLevel: userLevel })

        this.setState({ loading: true })
        const result = await req_page_ams_alumni(userCode, current, pageSize, columnSort, orderBy, searchField, searchValue, filterStatus, token)
        this.setState({ loading: false })
        //console.log(result)
        if (result.total > 0) {
            const { total } = result
            const items = result.data
            const pagination = { current: this.current, pageSize: this.state.pagination.pageSize, total }
            this.setState({ items, pagination })
            //console.log(this.state);
        } else {
            const items = []
            const pagination = { current: 1, pageSize: this.state.pagination.pageSize, total: 0 }
            this.setState({ items, pagination })
        }
    }

    api_downloadfile_items = async () => {
        const { userLevel, searchField, searchValue, filterStatus } = this.state
        const { token, userCode } = this.props.user

        // download file data
        const fileUrl = await req_downloadfile_ams_employer(userCode, userLevel, searchField, searchValue, filterStatus, token)

        // download file link      
        let a = document.createElement('a');
        a.href = API_BASE + fileUrl;
        a.target = '_blank'
        a.download = '校友雇主清單';
        a.click();
    }

    // 數據配置設定 ////////////////////////////////////////////// 
    init_columns = () => {
        this.columns = [
            {
                title: '姓名',
                dataIndex: 'AlumniName',
                width: 25,
                render: (field) => {
                    return (
                        <div className='text-center'>
                            <span style={{ fontSize: '1.3em' }}> {field}</span>
                        </div>
                    )
                },
            },
            {
                title: '公司',
                dataIndex: 'JobCompany',
                width: 40,
                responsive: ['md'],
                render: (field) => {
                    return (
                        <div>
                            <span style={{ fontSize: '1.3em' }}> {field}</span>
                        </div>
                    )
                },
            },
            {
                title: '職務',
                dataIndex: 'JobTitle',
                width: 40,
                responsive: ['md'],
                render: (field) => {
                    return (
                        <div className='text-center'>
                            <span style={{ fontSize: '1.3em' }}> {field}</span>
                        </div>
                    )
                },
            },
            {
                title: '電話',
                dataIndex: 'JobTelephone',
                width: 20,
                render: (field) => {
                    return (
                        <div>
                            <span style={{ fontSize: '1.3em' }}> {field}</span>
                        </div>
                    )
                },
            },
            {
                title: '地址',
                dataIndex: 'JobAddress',
                width: 70,
                responsive: ['lg'],
            },
            {
                title: '雇主姓名',
                dataIndex: 'JobBossName',
                width: 25,
                responsive: ['lg'],
                render: (field) => {
                    return (
                        <div className='text-center'>
                            <span style={{ fontSize: '1.3em' }}> {field}</span>
                        </div>
                    )
                },
            },
            {
                title: '雇主電郵',
                dataIndex: 'JobBossEmail',
                width: 50,
                responsive: ['lg'],
            },
        ]
    }

    // 操作互動處理 //////////////////////////////////////////////   
    handle_page_size_change = (current, size) => {
        //console.log(size)
        this.setState({
            pagination: {
                current: current,
                pageSize: size
            }
        }, () => {
            this.api_page_items(current)
        })
    }

    handle_table_change = (pagination, filters, sorter, extra) => {
        if (filters) {
            const status = [...Object.values(filters).filter(Boolean)][0]
            if (status) {
                this.setState({ filterStatus: status }, () => {
                    this.api_page_items(pagination.current)
                });
            } else {
                this.setState({ filterStatus: '' }, () => {
                    this.api_page_items(pagination.current)
                });
            }
        } else {
            this.api_page_items(pagination.current)
        }
    }

    handle_data_download = () => {
        this.api_downloadfile_items()
    }

    handle_data_refresh = () => {
        this.api_page_items(this.current)
    }

    /////////////////////////////////////////////////////////////     
    render() {
        const { loading, items, pagination, searchValue, deviceWidth } = this.state

        const title = (
            <span>
                <Input placeholder="畢業年班" style={{ width: 150, margin: '0 5px' }} value={searchValue} onChange={event => this.setState({ searchValue: event.target.value })} />
                <Button type='primary' onClick={() => this.api_page_items(1)}><i className="fas fa-search element-hidden"></i> 查詢</Button>
                {' '}
                <Tooltip placement="top" title="重新整理"><Button type='primary' onClick={() => this.handle_data_refresh()}><i className="fas fa-sync-alt"></i></Button></Tooltip>
                {' '}
                {deviceWidth > 600 ? (<><Button type='primary' onClick={() => this.handle_data_download()}><i className="fas fa-cloud-download-alt element-hidden"></i> 下載</Button></>) : ''}
            </span>
        )
        return (
            <Card title={title}>
                <Table
                    bordered
                    scroll={{ y: 480 }}
                    loading={loading}
                    rowKey='Uid'
                    dataSource={items}
                    onChange={this.handle_table_change}
                    pagination={{
                        ...pagination,
                        responsive: true,
                        showQuickJumper: true,
                        showSizeChanger: true,
                        pageSizeOptions: [5, 10, 20, 50, 100],
                        // onChange: this.api_page_applycase,
                        onShowSizeChange: this.handle_page_size_change
                    }}
                    columns={this.columns}
                />
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(EmployerManage)